import script from "./cityList.vue?vue&type=script&setup=true&lang=ts"
export * from "./cityList.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__